// get all contributors
export const contributorsQuery = `*[_type == "contributor"]{
    _id,
    name,
    slug,
    image,
    bio
}`

// get a single contributor by its slug
export const contributorQuery = `*[_type == "contributor" && slug.current == $slug][0]{
    _id,
    name,
    slug,
    image,
    bio
}`